function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  width: 40.8333,
  height: 40,
  rx: 7,
  fill: "url(#paint0_linear)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28.8016 11.6887L25.0823 9.28874C24.5667 8.95725 23.9004 9.34178 23.9004 9.97029V14.1259C23.9004 14.4043 24.0383 14.6616 24.2655 14.8074L26.5323 16.2713L27.4385 16.8547C27.9337 17.1756 27.7167 17.9685 27.1321 17.9685H24.6713C24.245 17.9685 23.8979 18.3292 23.8979 18.772V23.0098C23.8979 24.8688 22.3586 26.3592 20.5359 26.1815C18.9482 26.0251 17.7662 24.5745 17.7662 22.917V19.5119V17.9738V12.3703C17.7662 12.0918 17.6284 11.8346 17.4012 11.6887L13.6819 9.28874C13.1663 8.95725 12.5 9.34178 12.5 9.97294V14.1285C12.5 14.407 12.6378 14.6642 12.865 14.8101L15.1318 16.2739L16.0381 16.8573C16.5333 17.1782 16.3163 17.9712 15.7317 17.9712H13.2735C12.8472 17.9738 12.5 18.3318 12.5 18.7773V22.8242C12.5 27.534 16.0483 31.5225 20.5819 31.6631C25.2916 31.8089 29.1667 27.8708 29.1667 23.0098V17.9738V12.3703C29.1667 12.0945 29.0288 11.8346 28.8016 11.6887Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 23.6289,
  y1: -7.30769,
  x2: -1.04533,
  y2: 21.8185,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#7B90FF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#6F62FF"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.7b5940ea.svg";
export { ForwardRef as ReactComponent };